import { SvgIcon, SvgIconProps } from '@mui/material';

export const Reactivate = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      d="M12 1.25c-3.211 0-5.862 1.337-7.686 2.64A17.12 17.12 0 0 0 2.75 5.153V3v-.75h-1.5V3v4 .75H2h3.5.75v-1.5H5.5 3.773a15.62 15.62 0 0 1 1.413-1.14C6.862 3.913 9.211 2.75 12 2.75c2.83 0 5.129.94 6.72 2.53s2.53 3.89 2.53 6.72-.94 5.129-2.53 6.72-3.89 2.53-6.72 2.53c-5.537 0-9.25-4.643-9.25-9.25v-.75h-1.5V12c0 5.334 4.287 10.75 10.75 10.75 3.17 0 5.871-1.06 7.78-2.97s2.97-4.61 2.97-7.78-1.06-5.871-2.97-7.78S15.17 1.25 12 1.25zm4.555 8.755l.505-.555-1.11-1.009-.505.555-4.471 4.918L9.53 12.47l-.53-.53L7.939 13l.53.53 2 2 .556.556.529-.582 5-5.5z"
      fill="currentColor"
    />
  </SvgIcon>
);
